import { createResource, getResource, readUrlObjectBased, throwOnApiError } from "./api";

// The viewer's own follow row for one followable (0 or 1 — unique per profile+followable).
const getMine = async ({ profileId, followableType, followableId }) => {
  const url = readUrlObjectBased("follows", {
    conditionParams: {
      profile_id: `eq.${profileId}`,
      followable_type: `eq.${followableType}`,
      followable_id: `eq.${followableId}`,
    },
  });
  return getResource(url);
};

// The viewer's active non-hashtag follows (promoters/media/experts/products), most-recent first.
// mute == unfollow for people, so only follow_status "follow" is returned. `limit` bounds the read
// (PostgREST caps at 1000; busiest real account ~850) and surfaces truncation via `remainingRows`.
const listMinePeople = async ({ profileId, limit = 1000 }) => {
  const url = readUrlObjectBased("follows", {
    conditionParams: {
      profile_id: `eq.${profileId}`,
      followable_type: "neq.MatchFeed::Hashtag",
      follow_status: "eq.follow",
      order: "followed_at.desc",
      limit: `${limit}`,
    },
  });
  return getResource(url);
};

// Set follow status ("follow" | "mute" | "block") for one followable; the endpoint upserts
// (mute == unfollow, there is no delete). Throws on a non-2xx so callers can roll back optimistic UI.
const setStatus = async ({ profileId, followableType, followableId, followStatus }) => {
  const attributes = {
    profile_id: profileId,
    followable_type: followableType,
    followable_id: followableId,
    follow_status: followStatus,
  };
  return throwOnApiError(await createResource("/match_feed/api/follows", { data: { attributes } }));
};

export default { getMine, listMinePeople, setStatus };
